import KeenSlider from 'keen-slider';

let sliderWrapperEl = document.querySelector('.best-authors__slider');

if(sliderWrapperEl) {
  sliderWrapperEl.style.display = 'block';

  const sliderEl = sliderWrapperEl.querySelector('.keen-slider');
  const prevEl = sliderWrapperEl.querySelector('.swiper-button-prev');
  const nextEl = sliderWrapperEl.querySelector('.swiper-button-next');

  console.log(sliderEl);

  const slider = new KeenSlider(sliderEl, {
    slides: {
      perView: 1,
      spacing: 20
    },
    breakpoints: {
      '(min-width: 700px)': {
        slides: {
          perView: 2,
          spacing: 20
        }
      },
      '(min-width: 992px)': {
        slides: {
          perView: 3,
          spacing: 20
        }
      },
      '(min-width: 1200px)': {
        slides: {
          perView: 4,
          spacing: 20
        }
      }
    },
    created() {
      window.lazyObserver.observe();
    }
  });

  prevEl.onclick = () => slider.prev();
  nextEl.onclick = () => slider.next();
}
